

































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import pagelist from "@/components/pagelistcomponent";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
@Component
export default class systemsetting extends pagelist {
  get autoTradeproxy() {
    return new proxy.SystemSettingServiceProxy();
  }
  model: proxy.SystemSettingDto = new proxy.SystemSettingDto();
  platfroms = [];
  autotimes = [];
  getpage() {
    this.autoTradeproxy.queryModel().then((x) => {
      this.model = x;
      this.autotimes = [x.inStartTime || '', x.inEndTime || '']
    });
  }
  async created() {
    this.getpage();
  }
  ClearCache(){
    this.autoTradeproxy.clearCache().then(()=>{
      this.$Notice.success({title:"全局缓存清除成功"});
    })
  }
  save() {
    if (this.model.isEnableAuto) {
      if (this.autotimes.length && this.autotimes.length > 0) {
        this.model.inStartTime = this.autotimes[0];
        this.model.inEndTime = this.autotimes[1];
        var fil = this.autotimes.filter(x => x != '');
        if (fil.length == 0) {
          this.$Modal.error({ title: '错误警告', content: '你已经选择开启自动系统进单，需要选择自动进单时间范围' })
          return;
        }
      } else {
        this.$Modal.error({ title: '错误警告', content: '你已经选择开启自动系统进单，需要选择自动进单时间范围' })
        return;
      }
    }
    this.autoTradeproxy.save(this.model).then(() => {
      this.getpage();
      this.$Notice.success({ title: "保存成功" });
    });
  }
}
